import React from "react"

const Blog = () => {

    return(
        <section className="py-5 bg-light">
        <div className="container">
            <h2 className="text-center mb-4 fw-bold text-uppercase" style={{ color: '#38C6C3' }}>
            Explore Fibre Insights
            </h2>
            <p className="text-center mb-5 text-muted">
            Stay informed with trends, tips & updates on fibre technology and digital transformation.
            </p>

            <div className="row">
            {/* Article 1 */}
            <div className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow">
                <div className="card-body">
                    <h5 className="card-title fw-bold" style={{ color: '#0f174f' }}>
                    Why Fibre Beats Traditional Internet
                    </h5>
                    <p className="card-text text-muted">
                    Discover how fibre optics drastically improve speed, reliability, and performance compared to copper.
                    </p>
                    <a href="#" className="text-decoration-none fw-semibold" style={{ color: '#38C6C3' }}>
                    Read More →
                    </a>
                </div>
                </div>
            </div>

            {/* Article 2 */}
            <div className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow">
                <div className="card-body">
                    <h5 className="card-title fw-bold" style={{ color: '#0f174f' }}>
                    How Fibre Powers Remote Work & Business Growth
                    </h5>
                    <p className="card-text text-muted">
                    See how fibre internet enables seamless video conferencing, cloud access, and productivity for teams.
                    </p>
                    <a href="#" className="text-decoration-none fw-semibold" style={{ color: '#38C6C3' }}>
                    Read More →
                    </a>
                </div>
                </div>
            </div>

            {/* Article 3 */}
            <div className="col-md-4 mb-4">
                <div className="card h-100 border-0 shadow">
                <div className="card-body">
                    <h5 className="card-title fw-bold" style={{ color: '#0f174f' }}>
                    Fibre vs 5G: What’s Best for Your Business?
                    </h5>
                    <p className="card-text text-muted">
                    Explore the differences between fibre and 5G networks, and which is ideal for your connectivity needs.
                    </p>
                    <a href="#" className="text-decoration-none fw-semibold" style={{ color: '#38C6C3' }}>
                    Read More →
                    </a>
                </div>
                </div>
            </div>
            </div>
        </div>
        </section>
    );
};

export default Blog;